import { put, call, select, takeLatest } from 'redux-saga/effects';
import { notification } from 'antd';
import { push } from 'connected-react-router';
import ApiService from '../Services/ApiService';
import AppActions from '../Stores/App/Actions';
import InbOrd07Actions, { InbOrd07Types } from '../Stores/InbOrd07/Actions';

const getAppStore = state => state.app;

export function* inbOrd07FetchInbOrd07({ currentPage, sorts, filters, pageSize }) {
  try {
    yield put(InbOrd07Actions.inbOrd07FetchInbOrd07Loading(true));

    const processedSorts = [];
    Object.entries(sorts).forEach(entry => {
      const key = entry[0];
      const value = entry[1];
      processedSorts.push(`${key}:${value === 'ascend' ? 'ASC' : 'DESC'}`);
    });

    const processedFilters = [];
    Object.entries(filters).forEach(entry => {
      const key = entry[0];
      const value = entry[1];
      if (value) {
        processedFilters.push(`${key}:${value}`);
      }
    });

    const app = yield select(getAppStore);
    const getData = {
      page: currentPage,
      sorts: processedSorts,
      filters: processedFilters,
      pageSize
    };

    const result = yield call(
      ApiService.getApi, // function
      app.apiUrl,
      `inbOrd/indexProcess/INB_ORD_07/${app.curDivisionId}`,
      app.token,
      getData,
      'multipart/form-data' // params
    );

    if (result.isSuccess === true) {
      // if nowCurrentPage is more than lastPage, then nowCurrentPage = lastPage
      let nowCurrentPage = result.data.current_page;
      if (nowCurrentPage > result.data.last_page) {
        nowCurrentPage = result.data.last_page;
      }

      yield put(
        InbOrd07Actions.inbOrd07FetchInbOrd07Success(
          result.data.data,
          nowCurrentPage,
          result.data.last_page,
          result.data.total,
          result.data.per_page
        )
      );
    } else if (result.isTokenExpired === true) {
      yield put(AppActions.appTokenExpired(result.message));
    } else if (result.isPasswordExpired === true) {
      yield put(AppActions.appPasswordExpired(result.message));
    } else {
      yield call(notification.error, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
      });
    }
  } catch (error) {
    yield call(notification.error, {
      message: error.message,
      duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
    });
  } finally {
    yield put(InbOrd07Actions.inbOrd07FetchInbOrd07Loading(false));
  }
}

export function* inbOrd07CreateInbOrd07({ hdrIds }) {
  try {
    yield put(InbOrd07Actions.inbOrd07CreateInbOrd07Loading(true));

    const app = yield select(getAppStore);

    const postData = {
      hdrIds
    };

    const result = yield call(
      ApiService.postApi, // function
      app.apiUrl,
      `inbOrd/createProcess/INB_ORD_07`,
      app.token,
      postData
    );

    if (result.isSuccess === true) {
      yield put(InbOrd07Actions.inbOrd07CreateInbOrd07Success(result.data));

      yield call(notification.success, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_SUCCESS_MESSAGE_DURATION, 10)
      });
    } else if (result.isTokenExpired === true) {
      yield put(AppActions.appTokenExpired(result.message));
    } else if (result.isPasswordExpired === true) {
      yield put(AppActions.appPasswordExpired(result.message));
    } else {
      yield call(notification.error, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
      });
    }
  } catch (error) {
    yield call(notification.error, {
      message: error.message,
      duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
    });
  } finally {
    yield put(InbOrd07Actions.inbOrd07CreateInbOrd07Loading(false));
  }
}

export function* inbOrd07GoToDocument({ hdrId }) {
  const app = yield select(getAppStore);
  yield put(push(`${app.appPath}/trfOrdDetail/update/${hdrId}`));
}

export function* inbOrd07NewDocument() {
  const app = yield select(getAppStore);
  yield put(push(`${app.appPath}/trfOrdDetail/create/${app.curDivisionId}/TRANSFER_FROM_VAN`));
}

export const saga = [
  takeLatest(InbOrd07Types.INB_ORD07_FETCH_INB_ORD07, inbOrd07FetchInbOrd07),
  takeLatest(InbOrd07Types.INB_ORD07_CREATE_INB_ORD07, inbOrd07CreateInbOrd07),
  takeLatest(InbOrd07Types.INB_ORD07_GO_TO_DOCUMENT, inbOrd07GoToDocument),
  takeLatest(InbOrd07Types.INB_ORD07_NEW_DOCUMENT, inbOrd07NewDocument)
];
